<template>
  <div>
    <fieldset v-for="preference in preferences" v-bind:key="preference.id">
      <input-checkbox
        :label="preference.description"
        :value="preference.checked"
        v-on:change="togglePreference(preference)">
      </input-checkbox>
    </fieldset>
  </div>
</template>

<script>
  import { MarketingPreferences } from '../models/Booking'
  import inputCheckbox from './inputCheckbox'

  export default {
    name: 'marketingPreferences',
    props: [
      'preferences',
      'value'
    ],
    components: {
      inputCheckbox
    },
    methods: {
      togglePreference (preference) {
        preference.checked = !preference.checked
      },
      _toMarketingPreferences () {
        return new MarketingPreferences(this.preferences)
      }
    },
    watch: {
      preferences: {
        deep: true,
        handler: function () {
          this.$emit('input', this._toMarketingPreferences())
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// marketingPreferences.vue?62e77a92